import getApiClient from "./../../../../../shared/api";
import { showInfo, showError, clearNotifications } from "./../../../../../notifications/ducks/actions";

const url = "/film";

export const FETCH_SHOTS_OVERVIEW = "FETCH_SHOTS_OVERVIEW";
export const REORDER_SHOTS_ORDER = "REORDER_SHOTS_ORDER";
export const SAVE_SHOTS_ORDER = "SAVE_SHOTS_ORDER";
export const UPLOAD_SHOTS = "UPLOAD_SHOTS";
export const DELETE_MULTIPLE_SHOTS = "DELETE_MULTIPLE_SHOTS";

export function fetchShotsOverview(filmId, sceneId) {
  return (dispatch) => {
    dispatch({
      type: FETCH_SHOTS_OVERVIEW,
      payload: getApiClient().get(`${url}/${filmId}/Scene/${sceneId}/Shot/Overview`)
    });
  };
}

export function updateShotOrder(
  startIndex,
  endIndex,
  sourceDay,
  destinationDay
) {
  return (dispatch) => {
    dispatch({
      type: REORDER_SHOTS_ORDER,
      meta: { startIndex, endIndex, sourceDay, destinationDay }
    });
  };
}

export function saveShotsOrder(filmId, sceneId, shots) {
  return (dispatch) => {
    dispatch({
      type: SAVE_SHOTS_ORDER,
      payload: getApiClient().put(`/film/${filmId}/scene/${sceneId}/Shot/Order`, { shots }),
      meta: { shots },
    })
      .then((response) => {
        dispatch(showInfo(`Updated shot order`));
      })
      .catch((response) => {
        dispatch(showError(`Error updating shot order`));
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}

export function deleteMultipleShots(filmId, sceneId, shotIds) {
  return (dispatch) => {
    dispatch({
      type: DELETE_MULTIPLE_SHOTS,
      payload: getApiClient().post(`/film/${filmId}/scene/${sceneId}/Shot/deleteMultiple`, { shotIds }),
      meta: { shotIds }
    })
      .then((response) => {
        dispatch(showInfo(`Deleted ${shotIds.length} shot${shotIds.length !== 1 ? 's' : ''}`));
      })
      .catch((response) => {
        dispatch(showError(`Error deleting shots`));
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}